<template lang="pug">
  .paypal
    Spinner(:size="8" :thickness="3")
    PaypalButtons.buttons(
      :env="env"
      :style="style"
      :createOrder="order"
      :onApprove="approve"
      :onError="error"
    )
</template>

<script>
import uniqid from 'uniqid';
import { get } from '@/helpers';
import { mapActions } from 'vuex';

export default {
    name: 'PayPal',
    props: {
        env: {
            type: String,
            default: 'sandbox',
            validator: value => ['sandbox', 'production'].includes(value)
        }
    },
    data: () => ({
        purchase: undefined,
        style: {
            // NOTE: does not work
            // color:  'blue',
            // shape:  'pill',
            // label:  'pay',
            // height: 40
        }
    }),
    methods: {
        async order() {
            const id = get(this.purchase, 'payment_gateway_response_id');
            return this.submit(id).then(purchase => {
                if (purchase.id) this.purchase = purchase;
                if (purchase.payment_gateway_response_id) return purchase.payment_gateway_response_id;
            });
        },
        approve() {
            const id = get(this.purchase, 'id');
            if (id) this.approvePayment(id);

            this.purchase = undefined;
        },
        error() {
            const errorMessage = {
                id: uniqid(),
                title: 'Fehler',
                text: 'PayPal meldet ein technisches Problem',
                type: 'error',
                autoclose: 8000
            };
            this.addMessage(errorMessage);
        },
        ...mapActions({
            submit: 'shop/submitCheckoutForm',
            approvePayment: 'shop/approvePayment',
            addMessage: 'message/add'
        })
    }
};
</script>

<style lang="sass">
.paypal
  // @apply flex flex-col
  position: relative
  min-height: 4rem
  .spinner-container
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    z-index: 0
  .buttons .paypal-buttons
    @apply bg-gray-100 relative
    min-height: 0 !important
</style>
